<template>
    

    <footer class="site-footer">
    <div class="footer-content">
        <div class="footer-brand">
            <img src="https://www.ouicsport.fr/images/LogoOuiCSport.png" alt="OuiCSport Logo">
            <p>SIREN : 852096536</p>
            <p>N° immatriculation Atout France : IM095220001</p>
        </div>
        

        <div class="footer-contact" style="bottom: -30%;position: relative;">
            <p><i class="fa fa-phone"></i>  +33 (0)6 86 80 05 67</p>
            <a href="mailto:contact@ouicsport.fr"><i class="fa fa-envelope"></i>    contact@ouicsport.fr</a>
        </div>

        <div class="footer-social">
            <div class="footer-partners">
                <img src="https://www.ouicsport.fr/images/logoatoutfrance.png" alt="Atout France Logo">
            </div>
            <p>Suivez-nous</p>
            <a href="https://facebook.com/ouicsport">
                <i class="fa fa-facebook-square"></i>
            </a>
            <a href="https://instagram.com/ouicsport">
                <i class="fa fa-instagram"></i>
            </a>
        </div>

       
    </div>
   
</footer>
<div class="footer-links">
    <a>OUICSPORT 2024</a>
    <a href="https://www.ouicsport.fr/CGU">CGU / CGV</a>
    <a href="https://www.ouicsport.fr/mentions-legales">Mentions Légales</a>
    <a href="https://www.ouicsport.fr/politique-de-confidentialite">Politique de Confidentialité</a>
</div>
</template>


<script>
import { isNative } from '@/api/base';

export default {
  name: 'AppFooter',
  setup() {
    return { isNative };
  }
}
</script>

<style>
/* Styles natifs (iOS / Android via Capacitor) — n'affectent JAMAIS le web. */
body.is-native .site-footer {
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
}

body.is-native .site-footer .footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 16px 16px;
  text-align: center;
}

body.is-native .site-footer .footer-brand,
body.is-native .site-footer .footer-contact,
body.is-native .site-footer .footer-social {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: static !important;
  bottom: auto !important;
}

body.is-native .site-footer .footer-brand img {
  max-width: 160px;
  height: auto;
}

body.is-native .site-footer .footer-brand p,
body.is-native .site-footer .footer-contact p,
body.is-native .site-footer .footer-contact a {
  font-family: 'Dosis', sans-serif;
  font-size: 14px;
  margin: 4px 0;
  color: #222;
}

body.is-native .site-footer .footer-contact a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 12px;
  text-decoration: none;
  color: #dd4124;
  -webkit-tap-highlight-color: transparent;
}

body.is-native .site-footer .footer-partners img {
  max-width: 110px;
  height: auto;
  margin-bottom: 8px;
}

body.is-native .site-footer .footer-social p {
  font-family: 'Gagalin', 'Dosis', sans-serif;
  color: #dd4124;
  letter-spacing: 0.5px;
  margin: 4px 0 8px;
}

body.is-native .site-footer .footer-social a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin: 0 6px;
  color: #dd4124;
  font-size: 24px;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

body.is-native .footer-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 16px calc(env(safe-area-inset-bottom, 0) + 16px);
  background: #f7f7f7;
}

body.is-native .footer-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  font-family: 'Dosis', sans-serif;
  font-size: 13px;
  color: #555;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

body.is-native .footer-links a:first-child {
  color: #dd4124;
  font-family: 'Gagalin', 'Dosis', sans-serif;
  letter-spacing: 0.5px;
}
</style>
